// import _ from 'lodash';
import xxtea from 'xxtea-node';
import * as types from '../mutation-types';
import { member } from '../../api';
import { SECRET_KEY } from '../../constants';

const state = {
  token: '',
  identity: null,
  expiresTime: null,
  addresses: [],
};

const getters = {
  isLogined: s => s.token !== '' || s.identity !== null || !!localStorage.getItem('token'),
  currentMember: s => s.identity,
  hasRole: s => role => s.identity && !!~s.identity.roles.indexOf(role),
};

const actions = {
  register({ commit }, params) {
    return member.register(params).then(({ data: response }) => {
      commit(types.REVEIVE_IDENTITY, response.data);
    });
  },
  // 在locatStorage里读取token信息
  loadTokenFromLocalStore({ commit, dispatch, state: s }) {
    const tokenFormLocalStore = localStorage.getItem('token');
    if (s.token === '' && tokenFormLocalStore !== null) {
      const data = JSON.parse(xxtea.decryptToString(tokenFormLocalStore, SECRET_KEY));
      const expireMs = data.expiresTime - Date.now();
      // 过时
      if (expireMs <= 0) {
        commit(types.REMOVE_TOKEN);
        return Promise.reject();
      }
      commit(types.SET_TOKEN, data.token);
      commit(types.SET_EXPIRE_TIME, data.expiresTime);
      return dispatch('getIdentity');
    }
    return Promise.resolve();
  },
  authenticate({ commit, dispatch }, params) {
    return member.authenticate(params)
      .then(({ data: response }) => {
        commit(types.RECEIVE_USER_TOKEN, response);
        return dispatch('getIdentity');
      });
  },
  adminLogin({ commit, dispatch }, params) {
    return member.adminLogin(params)
      .then(({ data: response }) => {
        commit(types.RECEIVE_USER_TOKEN, response);
        return dispatch('getIdentity');
      });
  },
  refreshToken({ commit, dispatch }) {
    return member.refresh().then(({ data: response }) => {
      commit(types.RECEIVE_USER_TOKEN, response.token);
    }, (error) => {
      if (error.response.status === 401) {
        return dispatch('logout');
      }
      return Promise.reject(error);
    });
  },
  getIdentity({ commit, state: s, dispatch }) {
    return member.identity(s.token)
      .then(({ data: response }) => {
        commit(types.REVEIVE_IDENTITY, response.data);
        dispatch('afterLogin');
      })
      .catch(() => {
        commit(types.REMOVE_TOKEN);
      });
  },
  afterLogin() {
    //
  },
  logout({ commit }) {
    commit(types.REMOVE_TOKEN);
    commit(types.REVEIVE_IDENTITY, null);
  },
  fetchAddress({ commit }) {
    return member.getAddresses().then(({ data: response }) => {
      commit(types.RECEIVE_ADDRESS, response.data);
    });
  },
  saveAddress({ commit }, params) {
    return member.newAddress(params).then(({ data: response }) => {
      commit(types.RECEIVE_NEW_ADDRESS, response.data);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_USER_TOKEN](s, response) {
    const expiresTime = Date.now() + (response.expires_in * 1000);
    s.token = response.token;
    s.expiresTime = expiresTime;
    const data = {
      token: response.token,
      expiresTime,
    };
    localStorage.setItem('token', xxtea.encryptToString(JSON.stringify(data), SECRET_KEY));
  },
  [types.SET_TOKEN](s, token) {
    s.token = token;
  },
  [types.SET_EXPIRE_TIME](s, expireTime) {
    s.expiresTime = expireTime;
  },
  [types.REMOVE_TOKEN](s) {
    s.token = '';
    localStorage.removeItem('token');
  },
  [types.REVEIVE_IDENTITY](s, data) {
    s.identity = data;
  },
  [types.RECEIVE_ADDRESS](s, data) {
    s.addresses = [...data];
  },
  [types.RECEIVE_NEW_ADDRESS](s, data) {
    s.addresses = [...s.addresses, data];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/member.js